var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _vm.orderId === null
        ? _c("no-data")
        : _c(
            "div",
            { staticClass: "container paddingTop10 orderListInfo" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "marginLeft10",
                  model: {
                    value: _vm.tabs,
                    callback: function ($$v) {
                      _vm.tabs = $$v
                    },
                    expression: "tabs",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "申请动态", name: "0" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "催单状态", name: "1" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "配送跟踪", name: "2" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "订单详情", name: "3" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "门店智控", name: "4" },
                  }),
                ],
                1
              ),
              _c("div", { staticStyle: { height: "72vh", overflow: "auto" } }, [
                _vm.tabs === "0"
                  ? _c(
                      "div",
                      [
                        _c("orderRefund", {
                          ref: "orderRefund",
                          attrs: { "order-id": _vm.orderId },
                          on: { handleConfirm: _vm.handleConfirm },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.tabs === "1"
                  ? _c(
                      "div",
                      [
                        _c("orderRemind", {
                          ref: "orderRemind",
                          attrs: { "order-id": _vm.orderId },
                          on: { handleConfirm: _vm.handleConfirm },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.tabs === "2"
                  ? _c(
                      "div",
                      {
                        staticClass: "ordListInfo paddingLeft10 paddingRight10",
                      },
                      [
                        _c("orderDelivery", {
                          ref: "orderDelivery",
                          attrs: { "order-id": _vm.orderId },
                          on: { handleConfirm: _vm.handleConfirm },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.tabs === "3"
                  ? _c(
                      "div",
                      [
                        _c("orderDetail", {
                          ref: "orderDetail",
                          attrs: { "order-id": _vm.orderId },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.tabs === "4"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "hHP flex directionColumn marginLeft10 marginRight10",
                      },
                      [
                        _c("orderStore", {
                          ref: "orderStore",
                          attrs: { "order-id": _vm.orderId },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c(
                "el-row",
                {
                  staticClass: "grey paddingTop10",
                  staticStyle: {
                    "text-align": "center",
                    "border-top": "1px solid rgb(235, 238, 245)",
                    position: "fixed",
                    bottom: "20px",
                    width: "530px",
                  },
                },
                [
                  _vm.tabs === "3"
                    ? _c(
                        "div",
                        { staticClass: "padding10 borderRadius5" },
                        [
                          _vm.orderInfo.bdelivery === 2
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: [
                                        "order:orderProcessing:selfPickupFinish",
                                      ],
                                      expression:
                                        "['order:orderProcessing:selfPickupFinish']",
                                    },
                                  ],
                                  attrs: { type: "success" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleOrderOver(
                                        _vm.orderInfo.corderNo
                                      )
                                    },
                                  },
                                },
                                [_vm._v("自提完成")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["order:orderProcessing:pickEdit"],
                                  expression:
                                    "['order:orderProcessing:pickEdit']",
                                },
                              ],
                              attrs: { type: "warning", plain: "" },
                              on: {
                                click: function ($event) {
                                  _vm.orderDialogVisible = true
                                },
                              },
                            },
                            [_vm._v("修改订单")]
                          ),
                          (_vm.orderInfo.bdelivery === 1 ||
                            _vm.orderInfo.bdelivery === 4) &&
                          (_vm.orderInfo.bstatus === 1 ||
                            _vm.orderInfo.bstatus === 2 ||
                            _vm.orderInfo.bstatus === 6 ||
                            _vm.orderInfo.bstatus === 10)
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: [
                                        "order:orderProcessing:humanDelivery",
                                      ],
                                      expression:
                                        "['order:orderProcessing:humanDelivery']",
                                    },
                                  ],
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.deliveryOrderVisible = true
                                    },
                                  },
                                },
                                [_vm._v("人工配送下单")]
                              )
                            : _vm._e(),
                          _vm.orderInfo.bdelivery !== 2 &&
                          (_vm.orderInfo.bstatus === 1 ||
                            _vm.orderInfo.bstatus === 2 ||
                            _vm.orderInfo.bstatus === 3 ||
                            _vm.orderInfo.bstatus === 4 ||
                            _vm.orderInfo.bstatus === 5 ||
                            _vm.orderInfo.bstatus === 6 ||
                            _vm.orderInfo.bstatus === 10 ||
                            _vm.orderInfo.bstatus === 12 ||
                            _vm.orderInfo.bstatus === 0)
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: [
                                        "order:orderProcessing:humanDelivery",
                                      ],
                                      expression:
                                        "['order:orderProcessing:humanDelivery']",
                                    },
                                  ],
                                  attrs: { type: "primary" },
                                  on: { click: _vm.handleQunyunDelivery },
                                },
                                [_vm._v("一键发单")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _vm.deliveryOrderVisible
                ? _c(
                    "el-dialog",
                    {
                      staticClass: "elDialog",
                      staticStyle: { "margin-top": "-10vh" },
                      attrs: {
                        "close-on-click-modal": false,
                        title: _vm.title,
                        visible: _vm.deliveryOrderVisible,
                        width: "1000px",
                        "append-to-body": "",
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.deliveryOrderVisible = $event
                        },
                      },
                    },
                    [
                      _vm.deliveryOrderVisible
                        ? _c("deliveryOrderDialog", {
                            attrs: {
                              "order-info": _vm.orderInfo,
                              title: _vm.title,
                            },
                            on: {
                              handleConfirm: _vm.handleConfirm,
                              handleClose: _vm.handleClose,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.orderDialogVisible
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        "close-on-click-modal": false,
                        title: "修改订单",
                        visible: _vm.orderDialogVisible,
                        width: "600px",
                        "append-to-body": "",
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.orderDialogVisible = $event
                        },
                      },
                    },
                    [
                      _vm.orderDialogVisible
                        ? _c("orderEdit", {
                            attrs: { "order-info": _vm.orderInfo },
                            on: { handleClose: _vm.handleClose },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }